module.exports = __webpack_public_path__ + "img/product_103.5da656d.webp";